import LicenseCardNotificationContainer from './container'
export default LicenseCardNotificationContainer
